import React from 'react';
import { useStore } from '../context/StoreContext';

const LoadingSpinner = ({ size = 'md', text = '', className = '' }) => {
  const { getLoadingIconUrl } = useStore();
  const iconUrl = getLoadingIconUrl();

  const sizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  const imgSize = sizeClasses[size] || sizeClasses.md;

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <img
        src={iconUrl}
        alt="Loading..."
        className={`${imgSize} object-contain`}
      />
      {text && (
        <p className="mt-3 text-sm text-brand-lightText font-serif italic">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;